var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacadamia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#FFE3B2;}\n\t.st2{fill:#FFEECC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,73.49c-3.98-1.35-7.59-3.63-10.56-6.6l-1.81-1.81l-0.12,0.12l-1.57,1.58 c-3.02,3.02-6.69,5.31-10.74,6.66c-14.42,4.8-24.76,17.78-24.76,33.06c0,19.36,16.6,35.05,37.07,35.05 c20.47,0,37.07-15.69,37.07-35.05C143.78,91.28,133.52,78.34,119.2,73.49z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 90.22,
    cy: 105.56,
    rx: 8.54,
    ry: 15.91
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacadamia);
export default __webpack_public_path__ + "static/media/Macadamia.1b488a88c3267e492a2479c8c51241ec.svg";
export { ForwardRef as ReactComponent };